var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      "view" != _vm.mode
        ? _c(
            "el-select",
            {
              staticStyle: { width: "100%" },
              attrs: {
                multiple: "",
                remote: "",
                "remote-method": _vm.remoteLoad,
                filterable: "",
                "allow-create": "",
                "default-first-option": "",
                placeholder: "点我选择, 或输入后回车"
              },
              on: { change: _vm.onChange },
              model: {
                value: _vm.tags,
                callback: function($$v) {
                  _vm.tags = $$v
                },
                expression: "tags"
              }
            },
            _vm._l(_vm.options, function(item) {
              return _c("el-option", {
                key: item,
                attrs: { label: item, value: item }
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      "view" == _vm.mode
        ? _c(
            "span",
            [
              _c(
                "el-popover",
                {
                  attrs: {
                    width: "450",
                    placement: "right",
                    "open-delay": 200,
                    trigger: "hover"
                  }
                },
                [
                  _vm._l(_vm.tags, function(tag) {
                    return _c(
                      "span",
                      { key: tag, staticClass: "tag_1 tag_3" },
                      [_vm._v(_vm._s(tag))]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { attrs: { slot: "reference" }, slot: "reference" },
                    _vm._l(_vm.tags, function(tag) {
                      return _c(
                        "span",
                        { key: tag, staticClass: "tag_1 tag_2" },
                        [_vm._v(_vm._s(tag))]
                      )
                    }),
                    0
                  )
                ],
                2
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba50fca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba50fca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketTag.vue
// module id = 740
// module chunks = 75